<template>
    <activix-pills :pills="pills" :model-value="selectedDivision" @update:model-value="onInput" />
</template>

<script>
    import { ActivixPills } from '@/components/activix-ui/index.ts';

    export default {
        emits: ['update-selected-division'],

        components: {
            ActivixPills,
        },

        props: {
            selectedDivision: {
                type: String,
                required: true,
            },
        },

        computed: {
            pills() {
                return ['all', 'new', 'used'].map((pill) => ({
                    name: pill,
                    label: this.$t(`inventory.division.${pill}`),
                }));
            },
        },

        methods: {
            onInput(val) {
                this.$emit('update-selected-division', val);
            },
        },
    };
</script>
